module.exports = __webpack_public_path__ + "img/help-desk.57192ab8.svg";